import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, Suspense as _Suspense, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c7c92e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table rel" }
const _hoisted_2 = { class: "s-content" }
const _hoisted_3 = { class: "top ft-w-6" }
const _hoisted_4 = { class: "s-content-title flex-bwn-ter" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fx-1" }, null, -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "goods-title" }
const _hoisted_8 = { class: "line--3" }
const _hoisted_9 = { style: {"max-width":"300px"} }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "text-ct rel" }

import Tipstishi from '@/components/IconPark/Tipstishi.vue'
import { ref, computed, watch } from 'vue'
import { t } from '@/plugins/i18n'
import ProductPanel from './ProductPanel.vue'
import AmountSet from '../components/AmountSet.vue'
import TableLike from '@/components/common/TableLike.vue'
import calcLadder from '@/util/calcLadder'
import { goodsPropName } from '@/util/useFormat'
import GoodsLink from '@/components/common/GoodsLink.vue'
import STable from '@/components/Table/index.vue'
import TableButton from '@/components/Table/TableButton.vue'
import { addAdt } from '@/apis/shopcart'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import { BASE_IMAGE } from '@/common/baseImage'
import { montageAddition, isNoWashAdditionCustomerSku } from '@/util/calcAdt'
import { ElMessage } from 'element-plus'
import { formatMoney } from '@/plugins/utils'
import { tCurrency } from '../country'


export default /*#__PURE__*/_defineComponent({
  props: ['list', 'isEdit', 'orderFlag'],
  emits: ['update:list'],
  setup(__props, { emit }) {

const props = __props


const hasSet = computed(() => new Set(props.list.map((v: any) => v.productSku)))
const allCheck = ref(false)
const isBatch = ref(false)
watch(
  () => props.list,
  (list) => {
    calcLadder(list, null)
    console.log(list, 'list')
    allCheck.value = list.length && list.every((v: any) => v.check)
  },
  { immediate: true, deep: true }
)
const columns = [
  {
    // label: t('商品图片'),
    prop: 'check',
    align: 'center',
    width: 60,
    slotName: 'checkAll',
    slotHeadName: 'checkAllHead'
  },
  {
    label: t('商品图片'),
    prop: 'image',
    align: 'center',
    width: 140,
    slotName: 'image'
  },
  {
    label: t('商品名称'),
    prop: 'title',
    align: 'center',
    width: 280,
    slotName: 'title'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    width: 200,
    slotName: 'productPropertiesName'
  },
  {
    label: t('附加项'),
    prop: 'addition',
    align: 'center',
    width: 200,
    slotName: 'addition'
  },
  {
    label: `${t('单价')}`,
    prop: 'price',
    align: 'center',
    width: 180,
    slotName: 'price'
  },
  {
    label: t('单组数量'),
    prop: 'amount',
    align: 'center',
    width: 180,
    slotName: 'amount'
  },
  {
    label: t('操作'),
    prop: 'action',
    align: 'center',
    width: 180,
    slotName: 'action'
  }
]

const add = (item: any) => {
  // 校验多仓商品不可组合
  if (new Set([...props.list, ...item].map(v => v.sourceCountry)).size > 1) {
    ElMessage.error(t('不同货源地商品不支持组合'))
    return
  }
  const upList = [...props.list]
  for (let i = 0; i < item.length; i++) {
    const index = upList.findIndex((u: any) => u.shopProductSku === item[i].shopProductSku)
    if (index !== -1) {
      upList[index].unitNums += item[i].unitNums
    } else {
      upList.push(item[i])
    }
  }
  emit('update:list', upList)
}
const del = (index: number) => {
  const { list } = props
  emit('update:list', list.slice(0, index).concat(list.slice(index + 1)))
}
const changeAmount = (item: any, e: any) => {
  item.unitNums = e
  calcLadder(props.list, null)
}

const visible = ref(false)

const proxy: any = ref({})
const changeAdt = (goods: any, index: number) => {
  isBatch.value = false
  proxy.value = {
    ...goods,
    cartAdditionList: goods.additionList ?? [],
    proxyIndex: index
  }
}
const handleAdt = (t: any, index: any = undefined) => {
  const cartAdditionList = Array.isArray(t) ? t : []
  const noAdditionalFlag = t === 1 ? t : 0
  const proxyIndex = index || (index === 0 ? 0 : proxy.value.proxyIndex)
  const upList = [...props.list]
  if (isBatch.value) {
    upList.forEach((v: any) => {
      if (!v.check) return
      v.additionList = cartAdditionList.map(adtItem => {
        if (adtItem.additionCode === 1) {
          return {
            ...adtItem,
            washedlabelSpecification: v.additionList?.find(adt => adt.additionCode === 1)?.washedlabelSpecification ?? ''
          }
        }
        return adtItem
      })
      v.noAdditionalFlag = noAdditionalFlag
    })
  } else {
    upList[proxyIndex].additionList = cartAdditionList
    upList[proxyIndex].noAdditionalFlag = noAdditionalFlag
  }
  // upList[proxy.value.proxyIndex].additionNameJpSummary = cartAdditionList.map((adt:any) => adt.additionNameJp).join()
  emit('update:list', upList)

  // goods.value.cartAdditionList = cartAdditionList
}
const noAdd = (goods: any, index: number) => {
  handleAdt(1, index)
}
const changeCheck = (e) => {
  props.list.forEach((v: any) => {
    v.check = e
  })
}
const batchEditAddtion = () => {
  if (props.list.filter((v: any) => v.check).length === 0) {
    ElMessage.error(t('请选择商品'))
    return
  }
  isBatch.value = true
  proxy.value.cartAdditionList = []
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_radio = _resolveComponent("el-radio")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)(__props.isEdit ? '编辑组合商品' : '创建组合商品')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(_unref(t)('$商品组合信息$')) + " ", 1),
        _hoisted_5,
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: batchEditAddtion,
          class: "add-btn flex-cen-ter ml_10"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('批量编辑附加项')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true)),
          disabled: __props.orderFlag,
          class: "add-btn flex-cen-ter"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('添加商品')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createVNode(TableLike, _normalizeProps(_guardReactiveProps({
        columns: columns,
        data: __props.list,
        rowKey: 'productSku',
        headClass: 'group-headClass',
        itemClass: 'group-itemClass'
      })), {
        checkAllHead: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_checkbox, {
              modelValue: allCheck.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((allCheck).value = $event)),
              onChange: changeCheck
            }, null, 8, ["modelValue"])
          ])
        ]),
        checkAll: _withCtx(({item}) => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_checkbox, {
              modelValue: item.check,
              "onUpdate:modelValue": ($event: any) => ((item.check) = $event),
              disabled: item.orderFlag
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ])
        ]),
        image: _withCtx(({ item }) => [
          _createElementVNode("img", {
            referrerPolicy: "no-referrer",
            class: "pt_img",
            src: item.productSkuImg || item.productMainImg || _unref(BASE_IMAGE)
          }, null, 8, _hoisted_6)
        ]),
        title: _withCtx(({ item }) => [
          _createVNode(GoodsLink, {
            goods: item,
            class: "fx-1"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.productTitleJp), 1)
            ]),
            _: 2
          }, 1032, ["goods"])
        ]),
        productPropertiesName: _withCtx(({ item }) => [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((item.productPropertiesName || '').split(';'), (prop) => {
              return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
            }), 128))
          ])
        ]),
        addition: _withCtx(({ item, index }) => [
          (item.additionList)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                placement: "top",
                effect: "light"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(montageAddition)(item.additionList)), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(montageAddition)(item.additionList)), 1)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("label", {
              class: "btn primary-color",
              onClick: ($event: any) => (changeAdt(item, index))
            }, _toDisplayString(_unref(t)('编辑')), 9, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createVNode(_component_el_radio, {
              "model-value": !!item.noAdditionalFlag,
              size: "small",
              label: true,
              style: {"margin-right":"0"},
              onChange: ($event: any) => (noAdd(item, index))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('不需要检品')), 1)
              ]),
              _: 2
            }, 1032, ["model-value", "onChange"]), [
              [_vShow, !item.additionList?.length]
            ]),
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass(["abs add-valid-text", { active: item.showTip }])
            }, _toDisplayString(_unref(t)('附加项验证')), 3), [
              [_vShow, !(item.additionList?.length || item.noAdditionalFlag)]
            ])
          ])
        ]),
        price: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(_unref(formatMoney)(item.price) + _unref(tCurrency)('CNY', item.goodsCountry ?? item.country)), 1)
        ]),
        amount: _withCtx(({ item }) => [
          _createVNode(AmountSet, {
            amount: item.unitNums,
            "onUpdate:amount": (e) => changeAmount(item, e),
            disabled: __props.orderFlag
          }, null, 8, ["amount", "onUpdate:amount", "disabled"])
        ]),
        action: _withCtx(({ index }) => [
          _createVNode(_component_el_button, {
            type: "text",
            onClick: ($event: any) => (del(index)),
            disabled: __props.orderFlag
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('删除')), 1)
            ]),
            _: 2
          }, 1032, ["onClick", "disabled"])
        ]),
        _: 1
      }, 16)
    ]),
    (visible.value)
      ? (_openBlock(), _createBlock(ProductPanel, {
          key: 0,
          list: __props.list,
          visible: visible.value,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
          hasSet: _unref(hasSet),
          onCommit: add,
          countryCode: props.list[0]?.goodsCountry
        }, null, 8, ["list", "visible", "hasSet", "countryCode"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (proxy.value.cartAdditionList)
          ? (_openBlock(), _createBlock(AdditionDrawer, {
              key: 0,
              countryCode: proxy.value.goodsCountry,
              list: proxy.value.cartAdditionList,
              "onUpdate:list": _cache[3] || (_cache[3] = ($event: any) => ((proxy.value.cartAdditionList) = $event)),
              proxy: proxy.value,
              onCommit: handleAdt,
              type: "AdtOrder",
              title: _unref(t)('编辑'),
              isBatchEdit: isBatch.value
            }, null, 8, ["countryCode", "list", "proxy", "title", "isBatchEdit"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }))
  ]))
}
}

})